import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { RetirementCandidatesParams } from '@/types/api';

export function useRetirementCandidates(params: RetirementCandidatesParams = {}) {
  return useQuery({
    queryKey: analyticsKeys.retirementCandidates(params),
    queryFn: () => analyticsApi.retirementCandidates(params),
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
    placeholderData: keepPreviousData,
  });
}
